import type { NamespaceKeys } from '../types';

export const DEFAULT_NAMESPACE = 'common' satisfies NamespaceKeys;

/**
 * Carregados no boot; o resto carrega quando o `useTranslation(ns)` da rota monta (Suspense).
 * Só shell/portais globais e namespaces das camadas compartilhadas (ui-business, hooks, chat de IA),
 * que montam drawers/células no meio de páginas de outros módulos e trocariam a página pelo loader.
 */
export const BASE_NAMESPACES = [
  DEFAULT_NAMESPACE,
  'app-header',
  'login',
  'ui-business',
  'multiselects',
  'global-search',
  'ai',
  'suggestions',
  'business-manager',
  'geofences',
  'groups',
  'basic-value-onboarding',
  'contract-renewal',
  'devices',
  'drivers',
  'media',
  'monitoring',
  'vehicles',
] as const satisfies readonly NamespaceKeys[];
